//import vue router
import { createRouter, createWebHistory } from 'vue-router'

//define a routes
const routes = [
    {
        path: '/',
        redirect: '/orders'
    },
    {
        path: '/orders',
        name: 'order.index',
        component: () => import( /* webpackChunkName: "order.list" */ '@/views/orders/List.vue')
    },
    {
        path: '/orders/:id',
        name: 'order.view',
        component: () => import( /* webpackChunkName: "order.view" */ '@/views/orders/View.vue')
    },
    {
        path: '/manifests/',
        name: 'manifests.list',
        component: () => import( /* webpackChunkName: "manifests.list" */ '@/views/manifests/List.vue')
    }
]

//create router
const router = createRouter({
    history: createWebHistory(),
    routes  // config routes
})

export default router